<!--

	Responsive panel with 4 feature cards

-->
<template>
	<div class="mia-RewardAndSocialFeatures">
		<div class="container">
			<h1 v-tr="'landingpage_rewardandsocial_header'"
				class="mia-rewardAndSocialFeaturesHeader mia-Heading" 
			/>
			<div class="mia-tilesContainer">
				<div class="mia-FeatureList">
					<feature :feature-key="'earnRewards'" />
					<feature :feature-key="'newspaper'" />
					<feature :feature-key="'shop'" />
					<feature :feature-key="'community'" />
				</div>
			</div>
		</div>
	</div>
</template>
<script lang="ts">
import { Component, toNative, Vue } from "vue-facing-decorator";
import Feature from "@/Control/Vue/Lists/VueList/Items/Feature.vue";

@Component({
	components: {
		Feature
	}
})
export class RewardAndSocialFeaturesPanel extends Vue { }

export default toNative(RewardAndSocialFeaturesPanel);
</script>
<style lang="scss">
.mia-RewardAndSocialFeatures {
	display: flex;
	flex-direction: column;
	align-items: center;
}

.mia-rewardAndSocialFeaturesHeader {
	margin-bottom: theme.$mia-margin-size-xxl;
	text-align: center;
}

.mia-RewardAndSocialFeatures .mia-tilesContainer {
	.mia-FeatureList {
		display: grid;
		grid-template-columns: 50% 50%;
		grid-template-rows: 50% 50%;
	
		:nth-child(2) {
			grid-row: 2/3;
		}

		:nth-child(3) {
			grid-column: 2;
			grid-row: 1/2;
		}

		:nth-child(4) {
			grid-column: 2/3;
		}

		:nth-child(even) .mia-featureContent {
			flex-direction: row-reverse;
		}
	}
	@media (max-width: theme.$screen-sm-max) {
		.mia-FeatureList {
			grid-template-rows: 46% 1% 4% 1% 45%;
			height: auto;

			:nth-child(1) {
				grid-row: 1/5;
			}

			:nth-child(2) {
				grid-row: 5/6;
			}

			:nth-child(3) {
				grid-row: 1/2;
			}

			:nth-child(4) {
				grid-row: 2/6;
			}
		}
	}

	@media (max-width: theme.$screen-xs-max) {
		.mia-FeatureList {
			display: block;
		}
	}
}
</style>
